export default __webpack_public_path__ + "static/media/Close.597221f9.svg";